export function DoubleArrowRightIcon(): JSX.Element {
  return (
    <svg
      width="12"
      height="10"
      viewBox="0 0 12 10"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="M0.658447 8.825L4.47511 5L0.658447 1.175L1.83345 0L6.83345 5L1.83345 10L0.658447 8.825Z" />
      </g>
      <g transform="translate(5, 0)">
        <path d="M0.658447 8.825L4.47511 5L0.658447 1.175L1.83345 0L6.83345 5L1.83345 10L0.658447 8.825Z" />
      </g>
    </svg>
  );
}
